
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 77.02 88.19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M68.03 0H9a9 9 0 00-9 9v70.19a9 9 0 009 9h59a9 9 0 009-9V9a9 9 0 00-8.97-9zM47.16 60.37a4.39 4.39 0 01-4.38 4.38H15.72a4.39 4.39 0 01-4.38-4.38v-1a4.39 4.39 0 014.38-4.38h27.06a4.39 4.39 0 014.38 4.38zm19-17.93a4.39 4.39 0 01-4.38 4.38h-46a4.39 4.39 0 01-4.38-4.38v-1a4.39 4.39 0 014.32-4.32h46a4.39 4.39 0 014.38 4.38zm0-17.93a4.39 4.39 0 01-4.38 4.38h-46a4.39 4.39 0 01-4.38-4.38v-.95a4.39 4.39 0 014.38-4.38h46a4.39 4.39 0 014.38 4.38z","fill":"#6d86d5"}})])
          )
        }
      }
    